// src/utils/createAdmin.js
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export const createAdminUser = async () => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth, 
      "admin@ossinnovation.com", 
      "ADM1Noss!"
    );
    
    // Crear el documento del usuario en Firestore con rol superadmin
    await setDoc(doc(db, "usuarios", userCredential.user.uid), {
      uid: userCredential.user.uid,
      email: "admin@ossinnovation.com",
      nombre: "Administrador",
      apellido: "Sistema",
      rol: "superadmin",
      estado: "activo",
      fechaCreacion: new Date(),
      empresaId: null // Superadmin no pertenece a una empresa específica
    });
    
    console.log("Usuario administrador creado:", userCredential.user);
    alert("Usuario administrador creado exitosamente!\nEmail: admin@ossinnovation.com\nPassword: ADM1Noss!");
    return userCredential.user;
  } catch (error) {
    console.error("Error creando usuario administrador:", error);
    alert("Error: " + error.message);
  }
};
